import React, { useState, useMemo } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, PieChart, Pie, Cell, Legend, AreaChart, Area } from 'recharts';

// Raw data from CSV - aggregated by date and project
const rawData = [
  // Dec 9
  { date: '2025-12-09', project: 'RiskGuru-Prod', amount: 35.198 },
  { date: '2025-12-09', project: 'Asuretify Development', amount: 0.434 },
  { date: '2025-12-09', project: 'rag-extraction', amount: 0.000001 },
  { date: '2025-12-09', project: 'MCP_development', amount: 0.156 },
  { date: '2025-12-09', project: 'Kinetic Development', amount: 5.894 },
  { date: '2025-12-09', project: 'Prequal-Prod', amount: 0.001 },
  { date: '2025-12-09', project: 'Asuretify-Prod', amount: 1.510 },
  { date: '2025-12-09', project: 'kinetic-Prod', amount: 2.866 },
  { date: '2025-12-09', project: 'Riskguru Development', amount: 57.270 },
  // Dec 10
  { date: '2025-12-10', project: 'RiskGuru-Prod', amount: 21.578 },
  { date: '2025-12-10', project: 'Asuretify Development', amount: 0.146 },
  { date: '2025-12-10', project: 'Kinetic Development', amount: 3.722 },
  { date: '2025-12-10', project: 'Asuretify-Prod', amount: 1.278 },
  { date: '2025-12-10', project: 'kinetic-Prod', amount: 0.622 },
  { date: '2025-12-10', project: 'Riskguru Development', amount: 19.940 },
  // Dec 11
  { date: '2025-12-11', project: 'RiskGuru-Prod', amount: 39.146 },
  { date: '2025-12-11', project: 'Asuretify Development', amount: 0.226 },
  { date: '2025-12-11', project: 'development', amount: 0.139 },
  { date: '2025-12-11', project: 'Kinetic Development', amount: 5.223 },
  { date: '2025-12-11', project: 'Asuretify-Prod', amount: 0.534 },
  { date: '2025-12-11', project: 'kinetic-Prod', amount: 0.068 },
  { date: '2025-12-11', project: 'Riskguru Development', amount: 22.498 },
  // Dec 12
  { date: '2025-12-12', project: 'RiskGuru-Prod', amount: 3.760 },
  { date: '2025-12-12', project: 'Asuretify Development', amount: 0.074 },
  { date: '2025-12-12', project: 'asurtify', amount: 0.001 },
  { date: '2025-12-12', project: 'development', amount: 0.072 },
  { date: '2025-12-12', project: 'Kinetic Development', amount: 4.166 },
  { date: '2025-12-12', project: 'Asuretify-Prod', amount: 0.437 },
  { date: '2025-12-12', project: 'Riskguru Development', amount: 7.047 },
  // Dec 13
  { date: '2025-12-13', project: 'Asuretify-Prod', amount: 0.008 },
  { date: '2025-12-13', project: 'Riskguru Development', amount: 0.024 },
  // Dec 14
  { date: '2025-12-14', project: 'Asuretify-Prod', amount: 0.001 },
  // Dec 15
  { date: '2025-12-15', project: 'RiskGuru-Prod', amount: 26.976 },
  { date: '2025-12-15', project: 'Asuretify Development', amount: 0.765 },
  { date: '2025-12-15', project: 'asurtify', amount: 0.0001 },
  { date: '2025-12-15', project: 'Kinetic Development', amount: 1.350 },
  { date: '2025-12-15', project: 'Asuretify-Prod', amount: 0.352 },
  { date: '2025-12-15', project: 'Riskguru Development', amount: 14.207 },
  // Dec 16
  { date: '2025-12-16', project: 'RiskGuru-Prod', amount: 48.055 },
  { date: '2025-12-16', project: 'Asuretify Development', amount: 1.342 },
  { date: '2025-12-16', project: 'rag-extraction', amount: 0.354 },
  { date: '2025-12-16', project: 'Kinetic Development', amount: 0.466 },
  { date: '2025-12-16', project: 'Asuretify-Prod', amount: 0.665 },
  { date: '2025-12-16', project: 'kinetic-Prod', amount: 0.370 },
  { date: '2025-12-16', project: 'Riskguru Development', amount: 17.335 },
  // Dec 17
  { date: '2025-12-17', project: 'RiskGuru-Prod', amount: 23.930 },
  { date: '2025-12-17', project: 'Asuretify Development', amount: 0.149 },
  { date: '2025-12-17', project: 'rag-extraction', amount: 0.644 },
  { date: '2025-12-17', project: 'Kinetic Development', amount: 36.263 },
  { date: '2025-12-17', project: 'Prequal-Prod', amount: 0.001 },
  { date: '2025-12-17', project: 'Asuretify-Prod', amount: 0.246 },
  { date: '2025-12-17', project: 'kinetic-Prod', amount: 0.180 },
  { date: '2025-12-17', project: 'Riskguru Development', amount: 28.320 },
  // Dec 18
  { date: '2025-12-18', project: 'RiskGuru-Prod', amount: 5.678 },
  { date: '2025-12-18', project: 'Asuretify Development', amount: 0.370 },
  { date: '2025-12-18', project: 'rag-extraction', amount: 4.184 },
  { date: '2025-12-18', project: 'Kinetic Development', amount: 58.458 },
  { date: '2025-12-18', project: 'Asuretify-Prod', amount: 0.364 },
  { date: '2025-12-18', project: 'kinetic-Prod', amount: 0.109 },
  { date: '2025-12-18', project: 'Riskguru Development', amount: 67.261 },
  // Dec 19
  { date: '2025-12-19', project: 'RiskGuru-Prod', amount: 1.319 },
  { date: '2025-12-19', project: 'Asuretify Development', amount: 0.696 },
  { date: '2025-12-19', project: 'rag-extraction', amount: 5.472 },
  { date: '2025-12-19', project: 'Kinetic Development', amount: 6.671 },
  { date: '2025-12-19', project: 'Asuretify-Prod', amount: 1.294 },
  { date: '2025-12-19', project: 'kinetic-Prod', amount: 0.053 },
  { date: '2025-12-19', project: 'Riskguru Development', amount: 48.146 },
  // Dec 20
  { date: '2025-12-20', project: 'Asuretify-Prod', amount: 0.003 },
  { date: '2025-12-20', project: 'kinetic-Prod', amount: 0.044 },
  // Dec 21
  { date: '2025-12-21', project: 'Asuretify Development', amount: 0.073 },
  { date: '2025-12-21', project: 'Kinetic Development', amount: 0.0003 },
  { date: '2025-12-21', project: 'Asuretify-Prod', amount: 0.002 },
  { date: '2025-12-21', project: 'Riskguru Development', amount: 0.691 },
  // Dec 22
  { date: '2025-12-22', project: 'Asuretify Development', amount: 0.170 },
  { date: '2025-12-22', project: 'rag-extraction', amount: 3.444 },
  { date: '2025-12-22', project: 'Kinetic Development', amount: 0.001 },
  { date: '2025-12-22', project: 'Asuretify-Prod', amount: 0.345 },
  { date: '2025-12-22', project: 'kinetic-Prod', amount: 9.360 },
  { date: '2025-12-22', project: 'Riskguru Development', amount: 2.777 },
  // Dec 23
  { date: '2025-12-23', project: 'Asuretify Development', amount: 0.078 },
  { date: '2025-12-23', project: 'Kinetic Development', amount: 25.874 },
  { date: '2025-12-23', project: 'Asuretify-Prod', amount: 0.446 },
  { date: '2025-12-23', project: 'kinetic-Prod', amount: 2.916 },
  { date: '2025-12-23', project: 'Riskguru Development', amount: 71.105 },
  // Dec 24
  { date: '2025-12-24', project: 'RiskGuru-Prod', amount: 0.273 },
  { date: '2025-12-24', project: 'Asuretify Development', amount: 0.311 },
  { date: '2025-12-24', project: 'Asuretify-Prod', amount: 0.279 },
  { date: '2025-12-24', project: 'kinetic-Prod', amount: 0.038 },
  { date: '2025-12-24', project: 'Riskguru Development', amount: 0.007 },
  // Dec 25
  { date: '2025-12-25', project: 'Kinetic Development', amount: 0.0004 },
  { date: '2025-12-25', project: 'Riskguru Development', amount: 0.002 },
  // Dec 26
  { date: '2025-12-26', project: 'Asuretify Development', amount: 0.184 },
  { date: '2025-12-26', project: 'Asuretify-Prod', amount: 0.023 },
  { date: '2025-12-26', project: 'Riskguru Development', amount: 0.631 },
  // Dec 27
  { date: '2025-12-27', project: 'Asuretify-Prod', amount: 0.009 },
  { date: '2025-12-27', project: 'Riskguru Development', amount: 0.383 },
  // Dec 28
  { date: '2025-12-28', project: 'RiskGuru-Prod', amount: 0.001 },
  { date: '2025-12-28', project: 'Asuretify Development', amount: 0.144 },
  { date: '2025-12-28', project: 'Asuretify-Prod', amount: 0.002 },
  { date: '2025-12-28', project: 'Riskguru Development', amount: 0.002 },
  // Dec 29
  { date: '2025-12-29', project: 'RiskGuru-Prod', amount: 0.742 },
  { date: '2025-12-29', project: 'Asuretify Development', amount: 0.123 },
  { date: '2025-12-29', project: 'Asuretify-Prod', amount: 0.243 },
  { date: '2025-12-29', project: 'Riskguru Development', amount: 3.752 },
  // Dec 30
  { date: '2025-12-30', project: 'RiskGuru-Prod', amount: 0.272 },
  { date: '2025-12-30', project: 'Asuretify Development', amount: 0.260 },
  { date: '2025-12-30', project: 'Kinetic Development', amount: 55.841 },
  { date: '2025-12-30', project: 'Asuretify-Prod', amount: 0.241 },
  { date: '2025-12-30', project: 'kinetic-Prod', amount: 0.081 },
  { date: '2025-12-30', project: 'Riskguru Development', amount: 0.178 },
  // Dec 31
  { date: '2025-12-31', project: 'Asuretify Development', amount: 2.720 },
  { date: '2025-12-31', project: 'Kinetic Development', amount: 17.730 },
  { date: '2025-12-31', project: 'Asuretify-Prod', amount: 0.445 },
  { date: '2025-12-31', project: 'kinetic-Prod', amount: 0.060 },
  // Jan 1
  { date: '2026-01-01', project: 'Asuretify Development', amount: 0.085 },
  // Jan 2
  { date: '2026-01-02', project: 'RiskGuru-Prod', amount: 0.160 },
  { date: '2026-01-02', project: 'Asuretify Development', amount: 1.476 },
  { date: '2026-01-02', project: 'Kinetic Development', amount: 80.732 },
  { date: '2026-01-02', project: 'Asuretify-Prod', amount: 0.571 },
  { date: '2026-01-02', project: 'kinetic-Prod', amount: 0.183 },
  { date: '2026-01-02', project: 'Riskguru Development', amount: 1.272 },
  // Jan 3
  { date: '2026-01-03', project: 'Asuretify-Prod', amount: 0.005 },
  // Jan 4
  { date: '2026-01-04', project: 'Asuretify-Prod', amount: 0.003 },
  // Jan 5
  { date: '2026-01-05', project: 'RiskGuru-Prod', amount: 2.708 },
  { date: '2026-01-05', project: 'Asuretify Development', amount: 0.129 },
  { date: '2026-01-05', project: 'rag-extraction', amount: 0.098 },
  { date: '2026-01-05', project: 'Kinetic Development', amount: 280.635 },
  { date: '2026-01-05', project: 'Asuretify-Prod', amount: 0.558 },
  // Jan 6
  { date: '2026-01-06', project: 'RiskGuru-Prod', amount: 15.277 },
  { date: '2026-01-06', project: 'Asuretify Development', amount: 1.997 },
  { date: '2026-01-06', project: 'Kinetic Development', amount: 72.377 },
  { date: '2026-01-06', project: 'Asuretify-Prod', amount: 0.493 },
  { date: '2026-01-06', project: 'kinetic-Prod', amount: 0.102 },
  { date: '2026-01-06', project: 'Riskguru Development', amount: 2.307 },
  // Jan 7
  { date: '2026-01-07', project: 'Asuretify Development', amount: 0.392 },
  { date: '2026-01-07', project: 'Kinetic Development', amount: 96.664 },
  { date: '2026-01-07', project: 'Asuretify-Prod', amount: 0.763 },
  { date: '2026-01-07', project: 'kinetic-Prod', amount: 0.220 },
  { date: '2026-01-07', project: 'Riskguru Development', amount: 8.711 },
  // Jan 8
  { date: '2026-01-08', project: 'Asuretify Development', amount: 0.533 },
  { date: '2026-01-08', project: 'development', amount: 0.488 },
  { date: '2026-01-08', project: 'Kinetic Development', amount: 35.565 },
  { date: '2026-01-08', project: 'Asuretify-Prod', amount: 0.028 },
  { date: '2026-01-08', project: 'Riskguru Development', amount: 0.756 },
];

const COLORS = {
  'Kinetic Development': '#6366f1',
  'Riskguru Development': '#22c55e',
  'RiskGuru-Prod': '#f59e0b',
  'Asuretify-Prod': '#ef4444',
  'Asuretify Development': '#8b5cf6',
  'rag-extraction': '#ec4899',
  'kinetic-Prod': '#14b8a6',
  'development': '#f97316',
  'MCP_development': '#84cc16',
  'Prequal-Prod': '#06b6d4',
  'asurtify': '#a855f7',
};

export default function DecJanCostReport() {
  const [view, setView] = useState('overview');
  const [selectedProject, setSelectedProject] = useState('all');

  // Get unique projects
  const projects = useMemo(() => {
    const projectSet = new Set(rawData.map(d => d.project));
    return ['all', ...Array.from(projectSet).sort()];
  }, []);

  // Calculate project totals
  const projectTotals = useMemo(() => {
    const totals = {};
    rawData.forEach(d => {
      totals[d.project] = (totals[d.project] || 0) + d.amount;
    });
    return Object.entries(totals)
      .map(([name, value]) => ({ name, value, color: COLORS[name] || '#94a3b8' }))
      .sort((a, b) => b.value - a.value);
  }, []);

  // Calculate daily totals
  const dailyData = useMemo(() => {
    const dates = [...new Set(rawData.map(d => d.date))].sort();
    return dates.map(date => {
      const dayData = rawData.filter(d => d.date === date);
      const entry = { date };
      let total = 0;
      dayData.forEach(d => {
        if (selectedProject === 'all' || d.project === selectedProject) {
          entry[d.project] = d.amount;
          total += d.amount;
        }
      });
      entry.total = total;
      return entry;
    });
  }, [selectedProject]);

  // Calculate totals
  const totalCost = useMemo(() => rawData.reduce((sum, d) => sum + d.amount, 0), []);
  const filteredTotal = useMemo(() => {
    if (selectedProject === 'all') return totalCost;
    return rawData.filter(d => d.project === selectedProject).reduce((sum, d) => sum + d.amount, 0);
  }, [selectedProject, totalCost]);

  // Top projects for stacked chart
  const topProjects = projectTotals.slice(0, 5).map(p => p.name);

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  };

  // Monthly comparison
  const monthlyData = useMemo(() => {
    const dec = rawData.filter(d => d.date.startsWith('2025-12')).reduce((sum, d) => sum + d.amount, 0);
    const jan = rawData.filter(d => d.date.startsWith('2026-01')).reduce((sum, d) => sum + d.amount, 0);
    return [
      { name: 'December 2025', value: dec, color: '#6366f1' },
      { name: 'January 2026', value: jan, color: '#22c55e' },
    ];
  }, []);

  return (
    <div className="min-h-screen bg-gray-950 text-gray-100 p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-white mb-2">Injala Organization Cost Report</h1>
          <p className="text-gray-400">All Projects • December 9, 2025 — January 8, 2026</p>
        </div>

        {/* Summary Cards */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
          <div className="bg-gray-900 rounded-xl p-5 border border-gray-800">
            <p className="text-gray-400 text-sm mb-1">Total Cost</p>
            <p className="text-2xl font-bold text-indigo-400">${totalCost.toFixed(2)}</p>
          </div>
          <div className="bg-gray-900 rounded-xl p-5 border border-gray-800">
            <p className="text-gray-400 text-sm mb-1">Projects</p>
            <p className="text-2xl font-bold text-emerald-400">{projects.length - 1}</p>
          </div>
          <div className="bg-gray-900 rounded-xl p-5 border border-gray-800">
            <p className="text-gray-400 text-sm mb-1">Top Project</p>
            <p className="text-lg font-bold text-amber-400">{projectTotals[0]?.name}</p>
            <p className="text-gray-500 text-xs">${projectTotals[0]?.value.toFixed(2)}</p>
          </div>
          <div className="bg-gray-900 rounded-xl p-5 border border-gray-800">
            <p className="text-gray-400 text-sm mb-1">Daily Average</p>
            <p className="text-2xl font-bold text-purple-400">${(totalCost / 31).toFixed(2)}</p>
          </div>
        </div>

        {/* View Toggle */}
        <div className="flex flex-wrap gap-2 mb-6">
          {['overview', 'byProject', 'daily', 'stacked', 'monthly'].map((v) => (
            <button
              key={v}
              onClick={() => setView(v)}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                view === v
                  ? 'bg-indigo-600 text-white'
                  : 'bg-gray-800 text-gray-400 hover:bg-gray-700'
              }`}
            >
              {v === 'overview' && 'Project Breakdown'}
              {v === 'byProject' && 'By Project'}
              {v === 'daily' && 'Daily Trend'}
              {v === 'stacked' && 'Stacked View'}
              {v === 'monthly' && 'Monthly Split'}
            </button>
          ))}
        </div>

        {/* Project Filter (for daily views) */}
        {(view === 'daily') && (
          <div className="mb-6">
            <label className="text-gray-400 text-sm mr-3">Filter by Project:</label>
            <select
              value={selectedProject}
              onChange={(e) => setSelectedProject(e.target.value)}
              className="bg-gray-800 text-gray-100 rounded-lg px-4 py-2 border border-gray-700 focus:outline-none focus:border-indigo-500"
            >
              {projects.map(p => (
                <option key={p} value={p}>{p === 'all' ? 'All Projects' : p}</option>
              ))}
            </select>
            {selectedProject !== 'all' && (
              <span className="ml-4 text-gray-400">
                Selected Total: <span className="text-indigo-400 font-semibold">${filteredTotal.toFixed(2)}</span>
              </span>
            )}
          </div>
        )}

        {/* Charts */}
        <div className="bg-gray-900 rounded-xl p-6 border border-gray-800 mb-8">
          {view === 'overview' && (
            <>
              <h2 className="text-lg font-semibold mb-4">Cost by Project</h2>
              <div className="flex flex-col lg:flex-row gap-8">
                <div className="flex-1">
                  <ResponsiveContainer width="100%" height={400}>
                    <PieChart>
                      <Pie
                        data={projectTotals}
                        cx="50%"
                        cy="50%"
                        innerRadius={80}
                        outerRadius={140}
                        paddingAngle={2}
                        dataKey="value"
                      >
                        {projectTotals.map((entry, index) => (
                          <Cell key={`cell-${index}`} fill={entry.color} />
                        ))}
                      </Pie>
                      <Tooltip
                        contentStyle={{ backgroundColor: '#1f2937', border: '1px solid #374151', borderRadius: '8px' }}
                        formatter={(value) => [`$${value.toFixed(2)}`, 'Cost']}
                      />
                    </PieChart>
                  </ResponsiveContainer>
                </div>
                <div className="flex-1">
                  <div className="space-y-3">
                    {projectTotals.map((project, idx) => (
                      <div key={project.name} className="flex items-center justify-between">
                        <div className="flex items-center gap-3">
                          <div className="w-3 h-3 rounded-full" style={{ backgroundColor: project.color }}></div>
                          <span className="text-gray-300 text-sm">{project.name}</span>
                        </div>
                        <div className="flex items-center gap-4">
                          <span className="text-gray-400 text-sm">{((project.value / totalCost) * 100).toFixed(1)}%</span>
                          <span className="text-white font-semibold">${project.value.toFixed(2)}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </>
          )}

          {view === 'byProject' && (
            <>
              <h2 className="text-lg font-semibold mb-4">Project Cost Comparison</h2>
              <ResponsiveContainer width="100%" height={400}>
                <BarChart data={projectTotals} layout="vertical">
                  <CartesianGrid strokeDasharray="3 3" stroke="#374151" />
                  <XAxis type="number" stroke="#9ca3af" tickFormatter={(v) => `$${v}`} />
                  <YAxis type="category" dataKey="name" stroke="#9ca3af" width={150} fontSize={12} />
                  <Tooltip
                    contentStyle={{ backgroundColor: '#1f2937', border: '1px solid #374151', borderRadius: '8px' }}
                    formatter={(value) => [`$${value.toFixed(2)}`, 'Cost']}
                  />
                  <Bar dataKey="value" radius={[0, 4, 4, 0]}>
                    {projectTotals.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={entry.color} />
                    ))}
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </>
          )}

          {view === 'daily' && (
            <>
              <h2 className="text-lg font-semibold mb-4">
                Daily Costs {selectedProject !== 'all' && `— ${selectedProject}`}
              </h2>
              <ResponsiveContainer width="100%" height={350}>
                <BarChart data={dailyData}>
                  <CartesianGrid strokeDasharray="3 3" stroke="#374151" />
                  <XAxis
                    dataKey="date"
                    tickFormatter={formatDate}
                    stroke="#9ca3af"
                    fontSize={11}
                    angle={-45}
                    textAnchor="end"
                    height={60}
                  />
                  <YAxis stroke="#9ca3af" tickFormatter={(v) => `$${v}`} />
                  <Tooltip
                    contentStyle={{ backgroundColor: '#1f2937', border: '1px solid #374151', borderRadius: '8px' }}
                    formatter={(value) => [`$${value.toFixed(2)}`, 'Cost']}
                    labelFormatter={(label) => formatDate(label)}
                  />
                  <Bar dataKey="total" fill="#6366f1" radius={[4, 4, 0, 0]} />
                </BarChart>
              </ResponsiveContainer>
            </>
          )}

          {view === 'stacked' && (
            <>
              <h2 className="text-lg font-semibold mb-4">Daily Costs by Top 5 Projects</h2>
              <ResponsiveContainer width="100%" height={400}>
                <AreaChart data={dailyData}>
                  <CartesianGrid strokeDasharray="3 3" stroke="#374151" />
                  <XAxis
                    dataKey="date"
                    tickFormatter={formatDate}
                    stroke="#9ca3af"
                    fontSize={11}
                    angle={-45}
                    textAnchor="end"
                    height={60}
                  />
                  <YAxis stroke="#9ca3af" tickFormatter={(v) => `$${v}`} />
                  <Tooltip
                    contentStyle={{ backgroundColor: '#1f2937', border: '1px solid #374151', borderRadius: '8px' }}
                    formatter={(value) => [`$${value?.toFixed(2) || '0.00'}`, '']}
                    labelFormatter={(label) => formatDate(label)}
                  />
                  {topProjects.map((project) => (
                    <Area
                      key={project}
                      type="monotone"
                      dataKey={project}
                      stackId="1"
                      stroke={COLORS[project]}
                      fill={COLORS[project]}
                      fillOpacity={0.8}
                    />
                  ))}
                  <Legend />
                </AreaChart>
              </ResponsiveContainer>
            </>
          )}

          {view === 'monthly' && (
            <>
              <h2 className="text-lg font-semibold mb-4">December vs January</h2>
              <div className="flex items-center justify-center">
                <ResponsiveContainer width="100%" height={300}>
                  <PieChart>
                    <Pie
                      data={monthlyData}
                      cx="50%"
                      cy="50%"
                      innerRadius={80}
                      outerRadius={120}
                      paddingAngle={5}
                      dataKey="value"
                      label={({ name, value }) => `${name}: $${value.toFixed(2)}`}
                    >
                      {monthlyData.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.color} />
                      ))}
                    </Pie>
                    <Tooltip
                      contentStyle={{ backgroundColor: '#1f2937', border: '1px solid #374151', borderRadius: '8px' }}
                      formatter={(value) => [`$${value.toFixed(2)}`, 'Cost']}
                    />
                  </PieChart>
                </ResponsiveContainer>
              </div>
              <div className="flex justify-center gap-8 mt-4">
                <div className="flex items-center gap-2">
                  <div className="w-3 h-3 rounded-full bg-indigo-500"></div>
                  <span className="text-gray-400">December: ${monthlyData[0].value.toFixed(2)} ({((monthlyData[0].value / totalCost) * 100).toFixed(1)}%)</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-3 h-3 rounded-full bg-emerald-500"></div>
                  <span className="text-gray-400">January: ${monthlyData[1].value.toFixed(2)} ({((monthlyData[1].value / totalCost) * 100).toFixed(1)}%)</span>
                </div>
              </div>
            </>
          )}
        </div>

        {/* Insights */}
        <div className="bg-gray-900 rounded-xl p-6 border border-gray-800">
          <h2 className="text-lg font-semibold mb-4">Key Insights</h2>
          <div className="space-y-3">
            <div className="flex items-start gap-3">
              <div className="w-2 h-2 rounded-full bg-indigo-500 mt-2"></div>
              <p className="text-gray-300">
                <span className="font-semibold text-white">Kinetic Development dominates:</span> At ${projectTotals.find(p => p.name === 'Kinetic Development')?.value.toFixed(2)}, it accounts for {((projectTotals.find(p => p.name === 'Kinetic Development')?.value / totalCost) * 100).toFixed(1)}% of total costs
              </p>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-2 h-2 rounded-full bg-emerald-500 mt-2"></div>
              <p className="text-gray-300">
                <span className="font-semibold text-white">Riskguru (Dev + Prod) combined:</span> ${(projectTotals.find(p => p.name === 'Riskguru Development')?.value + projectTotals.find(p => p.name === 'RiskGuru-Prod')?.value).toFixed(2)} — second largest cost center
              </p>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-2 h-2 rounded-full bg-amber-500 mt-2"></div>
              <p className="text-gray-300">
                <span className="font-semibold text-white">January 5 spike:</span> Kinetic Development alone spent $280.63 on this day — the single highest daily spend
              </p>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-2 h-2 rounded-full bg-purple-500 mt-2"></div>
              <p className="text-gray-300">
                <span className="font-semibold text-white">Prod vs Dev split:</span> Production projects (RiskGuru-Prod, kinetic-Prod, Asuretify-Prod, Prequal-Prod) total ${(projectTotals.filter(p => p.name.includes('Prod')).reduce((sum, p) => sum + p.value, 0)).toFixed(2)} — only {((projectTotals.filter(p => p.name.includes('Prod')).reduce((sum, p) => sum + p.value, 0) / totalCost) * 100).toFixed(1)}% of spend
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

